import React from 'react';
import styles from './hiddenBlock.module.css';

/**
 * Bloc masqué (`isVisible: false`, le « Masquer » du classique) : absent du
 * site publié, atténué dans l'éditeur pour qu'on puisse encore le réafficher.
 */
export default function HiddenBlockFrame({ isVisible, isEditing, children }) {
  if (isVisible !== false) return children;
  if (!isEditing) return null;
  return (
    <div className={`${styles.frame} ${styles.hidden}`}>
      <span className={styles.hiddenBadge}>Masqué</span>
      {children}
    </div>
  );
}
